import type { SyntheticEvent } from 'react';

/*
 * focusVisibleAdded data attribute is added by this library https://github.com/WICG/focus-visible
 * which we use to control the focus outline style visibility. We can leverage it's existance
 * on an element to infer the input device which triggered the event.
 */
export const isKeyboardTriggeredEvent = (event: SyntheticEvent<HTMLElement>): boolean =>
  (event.target as HTMLElement).dataset['focusVisibleAdded'] === '';
